import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface GetDrugCostEntriesParams {
  timeHead?: string;
  timeTail?: string;
}
export function getDrugCostEntries(params: GetDrugCostEntriesParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/statistics/doctorDrugCostSale`,
    method: "GET",
    params,
  };
}
